import script from "./SearchFacetMaterials.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchFacetMaterials.vue?vue&type=script&lang=ts&setup=true"

import "./SearchFacetMaterials.vue?vue&type=style&index=0&id=21f46268&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f46268"]])

export default __exports__